import { ProductAccountingCategoryDetailPage } from '@/features/product-accounting-category/pages/ProductAccountingCategoryDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/admin/product-accounting-category/$id/detail',
)({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_accounting_category.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductAccountingCategoryDetailPage,
})